import { IQuestionModel } from '@care-portals/api-interfaces';

const QuestionModel = [
  {
    label: 'What is your height in feet and inches/cms?',
    field: 'sybilHRT_height',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_height'
    }
  },
  {
    label: 'What is your weight in pounds/kgs?',
    field: 'sybilHRT_weight',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_weight'
    }
  },
  {
    label: 'What is your age?',
    field: 'sybilHRT_age',
    type: 'info',
    answer: {
      type: 'number',
      name: 'sybilHRT_age'
    }
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'sybilHRT_sexAssignedAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'male',
          value: 'Male'
        },
        {
          key: 'female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'Consent (Pregnancy)',
    educationalSlide: `I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.

I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.

I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.

By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
    field: 'sybilHRT_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          class: 'option-decline',
          key: 'non_consent',
          value: 'I have read the information and do NOT wish to proceed'
        },
        {
          class: 'option-consent',
          key: 'consent',
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed'
        }
      ]
    }
  },
  {
    label: 'Are you currently pregnant or are you planning to become pregnant?',
    field: 'sybilHRT_currentOrPlanningPregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Could you possibly be pregnant at this time?',
    field: 'sybilHRT_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you currently breastfeeding?',
    field: 'sybilHRT_breastfeeding',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  //
  // ● 	Yes
  // ●     No
  //
  // ● 	Yes
  // ●     No
  //
  // ● 	Yes
  // ● 	No

  {
    label:
      "In the past 6 months, have you experienced any unusual or unexplained vaginal bleeding that's different from your regular period?",
    field: 'sybilHRT_unexplainedVaginalBleeding',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you been diagnosed with liver cirrhosis, liver failure, or advanced chronic kidney disease (CKD stage 4 or higher)?',
    field: 'sybilHRT_liverHealthIssues',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you believe that, or has your provider told you that you might be experiencing perimenopause or menopause?',
    field: 'sybilHRT_menopauseDiagnosis',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  // Do you experience any of the following symptoms?  Check all that apply:

  {
    label:
      'Do you experience any of the following symptoms?  Check all that apply:',
    field: 'sybilHRT_symptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'irregular',
          value: 'Irregular periods, skipped cycles, heavy bleeding'
        },
        {
          key: 'period12MonthAgo',
          value: 'Last period more than 12 months ago'
        },
        {
          key: 'hot',
          value: 'Hot flashes'
        },
        {
          key: 'night',
          value: 'Night sweats'
        },
        {
          key: 'mood',
          value: 'Mood swings or emotional instability'
        },
        {
          key: 'fatigue',
          value: 'Fatigue or low energy'
        },
        {
          key: 'anxiety',
          value: 'Anxiety'
        },
        {
          key: 'depression',
          value: 'Depression'
        },
        {
          key: 'sleep',
          value: 'Sleep disturbances or insomnia'
        },
        {
          key: 'cognitive',
          value:
            'Cognitive changes (brain fog, memory issues, difficulty concentrating)'
        },
        {
          key: 'vaginal',
          value: 'Vaginal dryness or irritation'
        },
        {
          key: 'painful',
          value: 'Painful intercourse (dyspareunia)'
        },
        {
          key: 'urinary',
          value: 'Urinary urgency or recurrent urinary tract infections (UTIs)'
        },
        {
          key: 'reducedLibido',
          value: 'Reduced libido'
        },
        {
          key: 'dry',
          value: 'Dry skin'
        },
        {
          key: 'thinning',
          value: 'Thinning hair or hair loss'
        },
        {
          key: 'joint',
          value: 'Joint/muscle pain, general body aches or “feeling unwell”'
        },
        {
          key: 'headaches',
          value: 'Headaches'
        },
        {
          key: 'weight',
          value: 'Weight gain, especially around the abdomen'
        },
        {
          key: 'other',
          value: 'Other'
        },
        {
          key: 'none',
          value: 'None of these',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Please describe any additional symptoms you’ve experienced',
    field: 'sybilHRT_additionalSymptom',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_additionalSymptom'
    }
  },
  {
    label:
      'How long have you been noticing symptoms related to hormonal changes?',
    field: 'sybilHRT_hormonalSymptoms',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_hormonalSymptoms'
    }
  },
  {
    label: 'Do any of the following apply to you? (Select all that apply)',
    field: 'sybilHRT_routingBetweenTreatmentType',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'diagnosedWithCancer',
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI/Non-HRT)'
          value:
            'I have been diagnosed with breast cancer, uterine cancer, or ovarian cancer? '
        },
        {
          key: 'familyWithCancer',
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI/Non-HRT)'
          value:
            'I have a strong family history of breast cancer, uterine cancer, or ovarian cancer? '
        },
        {
          key: 'experiencedStroke',
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI/Non-HRT)'
          value:
            'I have experienced a stroke, or “mini stroke” (transient ischemic attack, TIA))? '
        },
        {
          key: 'heartDisease',
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI/Non-HRT)'
          value:
            'I have been diagnosed with coronary artery disease (CAD), congestive heart failure, or uncontrolled hypertension (blood pressure)? '
        },
        {
          key: 'historyOfBloodClot',
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI or Non-HRT)'
          value:
            'I have a known history of blood clots such as deep vein thrombosis (DVT) or pulmonary embolism (PE)? '
        },
        {
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI/Non-HRT)'
          key: 'gallbladderIssues',
          value: 'I have current or recent gallbladder issues'
        },
        {
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI/Non-HRT)'
          key: 'inheritedBloodClottingDisorder',
          value: 'I have an inherited blood clotting disorder'
        },
        {
          key: 'SLEWithAntiBodies',
          //  >>> DISPLAY following conditional consent and SSRI/SNRI questionnaire (ROUTE TO SSRI/SNRI/Non-HRT)'
          value:
            'I have Systemic Lupus Erythematous(SLE) with positive antiphospholipid antibodies (lupus anticoagulant, anticardiolipin antibody, anti-β2-glycoprotein)'
        },
        {
          //(ROUTE TO SSRI/SNRI/Non-HRT)
          key: 'againstHRT',
          value:
            'I do NOT want to use any hormonal therapy(HRT) to manage my symptoms'
        },
        {
          // (ROUTE TO HRT)
          key: 'none',
          value: 'I do NOT have any of these',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: `Based on your medical history, or/and as per your request, you are not a candidate for hormonal therapy (HRT). However, if you are experiencing hot flashes, night sweats or mood swings, you may benefit from treatment with an SSRI/SNRI. SSRI/SNRI are commonly used antidepressants that can help reduce the frequency and intensity of hot flashes and night sweats, together with the mood swings.
Would you like to proceed with an SSRI/SNRI/Non-HRT treatment option?`,
    field: 'sybilHRT_NONHRT_RouteConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          class: 'option-decline',
          key: 'non_consent',
          value: 'No, I do not wish to proceed at this time.'
        },
        {
          class: 'option-consent',
          key: 'consent',
          value: 'Yes, I would like to proceed.'
        }
      ]
    }
  },
  {
    label:
      'Are you CURRENTLY receiving medications for the treatment of depression or anxiety?',
    field: 'sybilHRT_NONHRT_depressionTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you PREVIOUSLY taken supplements or medications for depression or anxiety?',
    field: 'sybilHRT_NONHRT_previousMedicationForDepression',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please provide the names of previous methods used, whether it was effective, and whether you experienced side effects',
    field: 'sybilHRT_NONHRT_previousMedicationForDepression_Details',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_NONHRT_previousMedicationForDepression_Details'
    }
  },
  {
    label: 'Do any of the following pertain to you? (select all that apply)',
    field: 'sybilHRT_NONHRT_disqualifyingConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'harming myself',
          value:
            'I am currently or within the last 3 months experiencing thoughts of harming myself or others'
        },
        {
          key: 'Schizophrenia',
          value:
            'I have been diagnosed with Schizophrenia, schizoaffective disorder, or bipolar disorder'
        },
        {
          key: 'hospitalization',
          value:
            'I have experienced a recent hospitalization for my mental health within the last year'
        },
        {
          key: 'kidney',
          value: 'I have known chronic kidney disease (stage 4 or greater)'
        },
        {
          key: 'liver',
          value:
            'I have known liver disease such as liver cirrhosis or elevation of my liver enzymes'
        },
        {
          key: 'hyponatremia',
          value:
            'I have a known issue with hyponatremia (low blood sodium levels)'
        },
        {
          key: 'MAOIs',
          value:
            'I have recently stopped taking any MAOIs within the last two weeks (e.g., linezolid, phenelzine, tranylcypromine)'
        },
        {
          key: 'serotonin',
          value: 'I have experienced serotonin syndrome in the past'
        },
        {
          key: 'none',
          value: 'None of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    label:
      'Are you currently taking blood thinners or an antiarrhythmic (heart rhythm medication such as flecainide, sotalol, or amiodarone?',
    field: 'sybilHRT_NONHRT_bloodThinners',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have a history of severe allergic reactions to antidepressants, antipsychotics, or other psychiatric medications?',
    field: 'sybilHRT_NONHRT_allergy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Consent (SSRIs/SNRIs for the Treatment of Menopausal Hot Flashes):',
    educationalSlide: `
    Your healthcare provider has recommended using an SSRI (Selective Serotonin Reuptake Inhibitor) or an SNRI (Serotonin-Norepinephrine Reuptake Inhibitor) to help reduce the frequency and intensity of menopausal hot flashes. These medications can influence certain neurotransmitters in the brain, offering relief from hot flashes when hormonal therapy is not an option or is otherwise contraindicated.

    Medication Options:
Your healthcare provider will determine the most suitable medication and dosage based on your individual needs and medical history.  Some options may include paroxetine, desvenlafaxine, venlafaxine, escitalopram, or other.
Potential Benefits:
➢    Reduction in Hot Flashes: Decrease in the frequency, intensity, or duration of hot flashes.
➢    Improved Daily Comfort: Relief from sudden warmth, sweating, or disruptions that hot flashes can cause.
➢    Better Quality of Life: Possible improvement in sleep and daytime functioning due to fewer interruptions from hot flashes.

Possible Side Effects:
While many people tolerate these medications well, side effects can occur. Common side effects include:
➢    Nausea, dizziness, or lightheadedness
➢    Headache
➢    Dry mouth or changes in appetite
➢    Sexual dysfunction (e.g., decreased libido)
➢    Sleep disturbances (e.g., insomnia or drowsiness)
➢    Gastrointestinal issues (e.g., diarrhea or constipation)
➢    Anxiety, agitation, or restlessness (especially when starting or changing doses)

Rare or serious adverse reactions may include:
➢    Serotonin syndrome (symptoms may include confusion, rapid heartbeat, or fever)
➢    Worsening mood or suicidal thoughts/behaviors (most commonly noted in individuals under 25, but should be monitored in all patients)
➢    Severe allergic reactions (rash, swelling, difficulty breathing)
➢    Hyponatremia (low sodium levels), especially in older adults or those on diuretics

If you notice any concerning or persistent side effects, contact your healthcare provider immediately.

Important Warnings and Precautions:
➢    Suicidal or Homicidal Thoughts: If you or someone around you observes new or worsening thoughts of suicide or harm, seek immediate help by calling 911 (or your local emergency number) or going to the nearest emergency department. In the United States, you may also call the Suicide and Crisis Lifeline at 988.
➢    Drug Interactions: Certain medications (e.g., MAOIs, other antidepressants, or specific supplements) may interact with SSRIs/SNRIs. Inform your healthcare provider of all prescription, over-the-counter, and herbal products you use.
➢    Alcohol and Substances: Alcohol or recreational drug use can intensify side effects like dizziness and drowsiness. It is best to avoid or limit these unless your healthcare provider advises otherwise.
➢    Pre-Existing Conditions: Inform your healthcare provider of any significant medical conditions, including liver, kidney, or cardiovascular issues, or a history of seizures.
➢    Pregnancy and Breastfeeding: If you are pregnant, planning to become pregnant, or are breastfeeding, discuss this with your provider before starting or continuing these medications.
➢    Alternative Options for Hot Flashes
➢    Lifestyle Modifications: Such as dressing in layers, using fans or cool packs, avoiding triggers (caffeine, spicy foods, alcohol), and practicing relaxation techniques.
➢    Non-Hormonal Therapies: Other prescription medications or supplements (e.g., gabapentin, clonidine) may be discussed if SSRIs/SNRIs are not suitable.

Informed Consent and Acknowledgment:
I understand that:
➢    The medications listed above can be used to manage menopausal hot flashes.
➢    They may carry risks and potential side effects, ranging from mild to serious.
➢    Alternative treatment options have been explained to me, including lifestyle changes and other possible therapies.
➢    I should promptly report any adverse reactions or concerns to my healthcare provider.
➢    This consent is voluntary, and I may discontinue treatment at any time after consulting with my healthcare provider.

By selecting an option below, I indicate my decision regarding the use of SSRIs/SNRIs for hot flash management under the guidance of my healthcare provider:`,
    field: 'sybilHRT_NONHRT_HotFlashConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          class: 'option-decline',
          key: 'non_consent',
          value:
            'I have read the information, and I do not wish to proceed at this time.'
        },
        {
          class: 'option-consent',
          key: 'consent',
          value:
            'I have read and understand the information, and I wish to proceed with treatment.'
        }
      ]
    }
  },
  {
    label: 'Do you have an adhesive allergy?',
    field: 'sybilHRT_HRT_adhesiveAllergy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // (SYSTEMIC estrogen: TRANSDERMAL EXCEPT patch) >>> DISPLAY following conditional question 1
          key: 'yes',
          value: 'Yes'
        },
        {
          // DISPLAY following conditional question 2
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'What formulation of estradiol do you prefer:', // To include the links/cost on this page for those formulations:',
    field: 'sybilHRT_HRT_FormulationPreferred',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'divigel',
          value: 'Daily gel (Divigel)' // Map to Divigel'
        },
        {
          key: 'evamist',
          value: 'Daily spray (Evamist)' // Map to Evamist'
        }
      ]
    }
  },
  {
    label: 'What formulation of estradiol do you prefer:', //  To include the links/cost on this page for those formulations:',
    field: 'sybilHRT_HRT_estradiolPreference',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'weekly',
          value: 'Weekly patch (Climara or generic)' // Map to Climara/generic patch'
        },
        {
          key: 'biWeekly',
          value: 'Bi-weekly patch (Lyllana/Minivell/Dotti)' // >>> DISPLAY following conditional question'
        },
        {
          key: 'divigel',
          value: 'Daily gel (Divigel)' // Map to Divigel'
        },
        {
          key: 'evamist',
          value: 'Daily spray (Evamist)' // Map to Evamist'
        }
      ]
    }
  },
  {
    label: 'What size of the patch do you prefer?',
    field: 'sybilHRT_HRT_sizePatch',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'minivell',
          value: 'The smallest on the market (Minivell)' // Map to Minivell patch'
        },
        {
          key: 'lyllana',
          value: 'I do not care (Lyllana)' // Map to Lyllana'
        },
        {
          key: 'dotti',
          value: 'I do not care (Dotti)' // Map to Dotti'
        }
      ]
    }
  },

  {
    field: 'sybilHRT_HRT_hrt_status',
    label:
      'Are you currently or have you ever been on hormone replacement therapy (HRT)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: "Yes, I'm currently taking HRT",
          key: 'currently_taking'
        },
        {
          value: 'Yes, I have taken HRT in the past',
          key: 'past_use'
        },
        {
          value: 'No, I have never taken HRT',
          key: 'never_taken'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_hrt_formulation',
    label: 'What HRT formulation are you on or have you tried?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_HRT_hrt_formulation'
    }
  },
  {
    field: 'sybilHRT_HRT_hrt_side_effects',
    label: 'Have you ever experienced side effects from your HRT?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_side_effects_details',
    label:
      'Please tell us which product you had side effects to and what symptoms that you experienced',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_HRT_side_effects_details'
    }
  },
  {
    field: 'sybilHRT_HRT_transdermal_side_effects',
    label:
      'Have you ever had side effects to TRANSDERMAL gel, or spray estrogen products?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_transdermal_reaction_details',
    label:
      'Please tell us about your reaction to TRANSDERMAL estrogen products',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_HRT_transdermal_reaction_details'
    }
  },
  {
    field: 'sybilHRT_HRT_oophorectomy',
    label:
      'Have you had a surgical resection of both of your ovaries (oophorectomy)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_oophorectomy_details',
    label:
      'Please provide further information about why you have had your ovaries removed',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_HRT_oophorectomy_details'
    }
  },
  {
    field: 'sybilHRT_HRT_vaginal_symptoms',
    label: 'Do you experience any of the following? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Painful intercourse',
          key: 'painful_intercourse'
        },
        {
          value: 'Vaginal dryness',
          key: 'vaginal_dryness'
        },
        {
          value: 'Vaginal irritation',
          key: 'vaginal_irritation'
        },
        {
          value: 'Urinary urgency',
          key: 'urinary_urgency'
        },
        {
          value: 'Recurrent UTIs',
          key: 'recurrent_utis'
        },
        {
          value: 'I do not experience any of these',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_vaginal_estrogen_preference',
    label: 'What is your preference for vaginal estrogen formulation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Bi-weekly inserts (Imvexxy)',
          key: 'imvexxy'
        },
        {
          value:
            'Vaginal ring that needs to be changed every 3 months (Femring)',
          key: 'femring'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_risk_factors',
    label: 'Do you have any of the following? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'I currently use nicotine products',
          key: 'nicotine'
        },
        {
          value:
            'I have a family history of blood clots such as a deep vein thrombosis (DVT) or pulmonary embolism (PE)',
          key: 'blood_clots_history'
        },
        {
          value: 'None of these apply to me',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_hysterectomy',
    label: 'Have you had a surgical resection of your uterus (hysterectomy)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_hysterectomy_details',
    label:
      'Please provide further information about why you have had a hysterectomy',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_HRT_hysterectomy_details'
    }
  },
  {
    field: 'sybilHRT_HRT_sleep_breast_tenderness',
    label: 'Do you experience difficulty with your sleep or breast tenderness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_bone_health',
    label:
      'Do you have thinning of your bones such as osteopenia or osteoporosis?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_current_medications',
    label: 'Are you currently taking any of the following medications?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Carbamazepine',
          key: 'carbamazepine'
        },
        {
          value: 'Felbamate',
          key: 'felbamate'
        },
        {
          value: 'Oxcarbazepine',
          key: 'oxcarbazepine'
        },
        {
          value: 'Phenytoin',
          key: 'phenytoin'
        },
        {
          value: 'Primidone',
          key: 'primidone'
        },
        {
          value: 'Rufinamide',
          key: 'rufinamide'
        },
        {
          value: 'Topiramate (> 200mg/day)',
          key: 'topiramate'
        },
        {
          value: 'Lamotrigine',
          key: 'lamotrigine'
        },
        {
          value: "St. John's Wort",
          key: 'st_johns_wort'
        },
        {
          value: 'Rifampin',
          key: 'rifampin'
        },
        {
          value: 'Rifabutin',
          key: 'rifabutin'
        },
        {
          value: 'Barbiturates',
          key: 'barbiturates'
        },
        {
          value: 'Bosentan',
          key: 'bosentan'
        },
        {
          value: 'None apply',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_blood_pressure',
    label: 'What has your blood pressure been over the last six months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: '<90/50',
          key: 'low'
        },
        {
          value: '90-139/50-89',
          key: 'normal'
        },
        {
          value: '140-159/90-99',
          key: 'elevated'
        },
        {
          value: '160/100 or above',
          key: 'high'
        },
        {
          value: 'My blood pressure has always been normal',
          key: 'always_normal'
        },
        {
          value: "I don't know my blood pressure",
          key: 'unknown'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_diabetes',
    label: 'Do you have diabetes?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_thyroid_dysfunction',
    label: 'Do you have thyroid dysfunction?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_thyroid_details',
    label: 'Please provide details on your thyroid dysfunction:',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_HRT_thyroid_details'
    }
  },
  {
    field: 'sybilHRT_HRT_family_history',
    label: 'Do you have a family history of: (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Early menopause (<45)',
          key: 'early_menopause'
        },
        {
          value: 'Cardiovascular disease',
          key: 'cardiovascular'
        },
        {
          value: 'Type 2 diabetes',
          key: 'type2_diabetes'
        },
        {
          value: 'Depression or anxiety',
          key: 'mental_health'
        },
        {
          value: 'Osteoporosis or fractures',
          key: 'osteoporosis'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_uterine_fibroids',
    label: 'Do you have uterine fibroids?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_fibroid_consent',
    label: 'Consent (Fibroid):',
    type: 'select',
    educationalSlide:
      'Hormone replacement therapy (HRT) carries certain risks, including the potential for existing uterine fibroids to grow and for abnormal or increased bleeding to occur. I acknowledge that these risks necessitate diligent and ongoing monitoring of my condition. To ensure my safety, I agree to undergo regular evaluations and diagnostic tests with my gynecologist, which may include physical examinations and imaging studies as recommended. By proceeding with HRT, I am giving my informed consent, understanding of this complication and that consistent follow-up care is essential to promptly address any changes in my health.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read and understand the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information and I wish to proceed with therapy',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_pcos',
    label: 'Do you have polycystic ovary syndrome (PCOS)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_pcos_consent',
    label: 'Consent (PCOS):',
    type: 'select',
    educationalSlide:
      'Having polycystic ovary syndrome (PCOS) can lead to irregular menstrual cycles, which may result in prolonged exposure of the endometrium (the lining of the uterus) to estrogen without the balancing effect of progesterone. This hormonal imbalance increases my risk of developing endometrial hyperplasia, a condition that can progress to endometrial cancer if left unchecked. I have been informed about this risk and the importance of vigilant monitoring to detect any early changes in the endometrium. To manage this risk effectively, I agree to undergo regular gynecological evaluations, including pelvic examinations and imaging studies, and any additional diagnostic procedures as recommended by my healthcare provider. I understand that consistent follow-up care is essential in mitigating the risk of endometrial cancer associated with PCOS.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read and understand the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information and I wish to proceed with therapy',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_endometriosis',
    label: 'Do you have a diagnosis of endometriosis?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_endometriosis_consent',
    label: 'Consent (endometriosis):',
    type: 'select',
    educationalSlide:
      'I understand that while taking hormone replacement therapy (HRT) for my menopausal symptoms, there is a possibility that my endometriosis-related pelvic pain may return. If I notice any resurgence of pelvic pain or other concerning symptoms, I agree to discontinue the HRT medication and promptly follow up with my gynecologist or healthcare provider for further evaluation and management.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read and understand the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information and I wish to proceed with therapy',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_continued_screening_consent',
    label: 'Acknowledgement of Continued Screening:',
    type: 'select',
    educationalSlide:
      'I acknowledge that the services provided by this clinic do not replace my primary care provider or routine medical care. I understand that I must continue to see my primary care provider or gynecologist for regular checkups and maintain all recommended health screenings, including (but not limited to) annual mammograms, pelvic exams with Pap tests, and any other screenings specific to my health needs.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read and understand the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information and I wish to proceed with therapy',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_questions_for_doctor',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sybilHRT_HRT_questions_for_doctor'
    }
  },
  {
    field: 'sybilHRT_HRT_main_consent',
    label: 'Consent (Hormone Replacement Therapy (HRT)):',
    type: 'select',
    educationalSlide:
      'This consent form provides information about the hormone replacement therapy (HRT) prescribed to you by your healthcare provider. It is important to understand the purpose, potential benefits, risks, side effects, and your responsibilities while undergoing this treatment. Please read the following information carefully.\n\nPlease note, studies have found that if you start therapy within 10 years of menopause onset, you will have a greater benefit compared to those who start after 10 years of onset.\n\nPurpose and Benefits:\nHormone replacement therapy with estradiol and progesterone is used to manage menopause-related symptoms and improve quality of life. Estradiol replaces declining estrogen levels, while progesterone helps protect the uterine lining from overgrowth. HRT may provide relief from the following symptoms:\n➢ Hot flashes and night sweats\n➢ Vaginal dryness and discomfort during intercourse\n➢ Sleep disturbances\n➢ Mood changes, irritability, and anxiety\n➢ Bone density loss associated with osteoporosis\nIn addition, HRT may help reduce the risk of fractures in postmenopausal women.\n\nPotential Risks and Side Effects:\nHRT is generally safe for many women, but like all medications, it carries potential risks and side effects. These vary depending on individual health factors and treatment duration.\n\nCommon side effects may include:\n➢ Nausea or upset stomach\n➢ Breast tenderness or swelling\n➢ Spotting or breakthrough bleeding\n➢ Bloating or fluid retention\n➢ Headaches or mood changes\n\nRare but serious risks may include:\n➢ Blood clots, which can lead to stroke, deep vein thrombosis, pulmonary embolism, and/or death\n➢ Increased risk of breast cancer (with long-term use in some women)\n➢ Gallbladder disease\n➢ Cardiovascular issues, including heart attack (primarily in women starting HRT later in menopause)\n\nPlease NOTE, this formulation MAY contain peanut oil and should not be used by individuals with peanut allergies. Please reach out to your provider if you have a peanut allergy.\n\nIf you experience severe symptoms, such as chest pain, difficulty breathing, sudden leg swelling, intense headaches, or yellowing of the skin or eyes, seek immediate medical attention.\n\nMonitoring Plan:\nYour healthcare provider will monitor your progress and response to HRT to ensure its continued safety and effectiveness. It is strongly recommended that you continue:\n➢ Periodic physical examinations and blood pressure checks\n➢ Mammograms and pelvic ultrasounds as needed\n➢ Routine blood tests as recommended by your primary care provider\n\nAlternative Treatments:\nYou have the right to discuss alternative approaches to managing menopause symptoms, including:\n➢ Non-hormonal medications\n➢ Lifestyle changes (e.g., diet, exercise, stress management)\n➢ Herbal supplements\n➢ Localized treatments for vaginal symptoms (e.g., estrogen creams or rings)\n\nYour Responsibilities:\nAs a patient, you are responsible for:\n➢ Following the instructions for using your medication as directed\n➢ Attending all follow-up appointments and undergoing recommended testing\n➢ Informing your provider of any new medications, supplements, or changes in your health\n➢ Reporting any concerning side effects or symptoms immediately\n\nBy selecting below, you confirm that you have read and understood the information provided. You acknowledge the potential benefits and risks associated with the prescribed hormone therapy. You agree to adhere to the recommended use, monitoring plan, and to communicate openly with your healthcare provider about any concerns.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information, and I do NOT wish to proceed.',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information, I understand the risks, and I would like to proceed.',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_HRT_identity_verification',
    label: 'Identity Verification',
    type: 'info',
    educationalSlide:
      "Upload a photo of a valid government-issued photo ID such as a driver's license or passport which has your picture, name and date of birth clearly visible. If applicable, upload a photo of the front and the back especially when using a military ID as your date of birth is on the back of the card. Make sure the photo is clear and legible.",
    answer: {
      type: 'text',
      rows: 1,
      name: 'sybilHRT_HRT_identity_verification'
    }
  },
  {
    field: 'sybilHRT_truthfulness_consent',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\nConsent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sybilHRT_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'sybilHRT_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    educationalSlide: '',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    type: 'info',
    isLast: true,
    answer: {}
  }
] as const;
export default QuestionModel;
